import { C } from "../data";
import Img from "./Img";
import Footer from "./Footer";

export default function AboutPage({ nav, aboutImages }) {
  const onGoShop = nav?.goShop;
  return (
    <>
      {/* ── HERO ── */}
      <section style={{ paddingTop:'var(--header-h, 60px)', background:C.ink, overflow:"hidden" }}>
        <div className="about-hero-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", minHeight:"80vh", alignItems:"stretch" }}>
          <div className="about-hero-text" style={{ display:"flex", flexDirection:"column", justifyContent:"center", padding:"80px 64px 80px 48px" }}>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:6, color:C.accent, marginBottom:28, textTransform:"uppercase" }}>
              About Underlooked
            </p>
            <h1 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:400, fontSize:"clamp(36px,5vw,68px)", lineHeight:1.1, color:C.bg, marginBottom:28 }}>
              움직임을<br/>위해 설계된 옷.
            </h1>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:14, fontWeight:300, lineHeight:2.2, color:"rgba(242,241,237,0.55)", maxWidth:420 }}>
              UNDERLOOKED은 스포츠와 일상의 경계를 허무는 옷을 통해, 더 많은 사람들이 더 자유롭게 움직일 수 있도록 합니다.<br/>
              “덜 의식할수록 더 자유로워집니다.”<br/>
              “움직임에 집중할 수 있도록.”<br/>
              “몸보다 움직임이 먼저 느껴지도록.”
            </p>
          </div>
          <Img src={aboutImages?.aboutHero || undefined} dark style={{ width:"100%", minHeight:480 }} label="BRAND HERO" />
        </div>
      </section>

      {/* ── BRAND STORY ── */}
      <section className="about-story-sec" style={{ background:C.bg, padding:"96px 48px" }}>
        <div style={{ maxWidth:1440, margin:"0 auto" }}>
          <div style={{ maxWidth:720, margin:"0 auto", textAlign:"center" }}>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:C.accent, marginBottom:20, textTransform:"uppercase" }}>Brand Story</p>
            <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:400, fontSize:"clamp(28px,4vw,48px)", lineHeight:1.2, marginBottom:32, color:C.ink }}>
              기능과 스타일 사이의<br/>정밀한 균형
            </h2>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:14, fontWeight:300, lineHeight:2.3, color:C.muted }}>
              움직임과 미감이 공존하는 옷, 운동할 때도 거리를 걸을 때도 어색하지 않은 옷을 만들고자 했습니다.
            </p>
          </div>
        </div>
      </section>

      {/* ── THREE VALUES ── */}
      <section className="about-values-sec" style={{ background:C.bg2, padding:"80px 48px" }}>
        <div style={{ maxWidth:1440, margin:"0 auto" }}>
          <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:C.accent, marginBottom:48, textTransform:"uppercase", textAlign:"center" }}>Our Values</p>
          <div className="about-values-grid" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:48 }}>
            {[
              { no:"01", title:"Performance First", body:"모든 제품은 실제 움직임을 기반으로 설계됩니다. 소재 선택부터 패턴 제작까지, 착용자의 동작을 최우선으로 고려합니다." },
              { no:"02", title:"Minimal Aesthetic", body:"불필요한 장식을 배제하고 실루엣 자체로 말하는 디자인. 시간이 지나도 질리지 않는 형태를 추구합니다." },
              { no:"03", title:"Conscious Making", body:"지속 가능한 소재와 제조 방식을 지속적으로 탐구합니다. 오래 입을 수 있는 품질이 최고의 환경 기여라고 믿습니다." },
            ].map(v => (
              <div key={v.no}>
                <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:4, color:C.border, marginBottom:16 }}>{v.no}</p>
                <h3 style={{ fontFamily:"'DM Serif Display',serif", fontWeight:400, fontSize:22, marginBottom:14, color:C.ink }}>{v.title}</h3>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, fontWeight:300, lineHeight:2.1, color:C.muted }}>{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── COLLECTION INTRO ── */}
      <section className="about-col-sec" style={{ background:C.ink, padding:"96px 48px 0" }}>
        <div className="about-col-grid" style={{ maxWidth:1440, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:2 }}>
          {(aboutImages?.collections?.length
            ? aboutImages.collections
            : [{ label:"TRAINING" }, { label:"PERFORMANCE" }, { label:"ESSENTIALS" }]
          ).map((item, idx) => (
            <div key={idx} style={{ position:"relative", overflow:"hidden" }}>
              <Img src={item?.img || undefined} dark style={{ aspectRatio:"3/4", width:"100%" }} label={`26 S/S — ${item?.label || ""}`} />
              <div style={{ position:"absolute", inset:0, zIndex:5, background:"linear-gradient(to top, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.18) 40%, transparent 70%)", pointerEvents:"none" }} />
              <div style={{ position:"absolute", bottom:24, left:24, zIndex:10 }}>
                <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:8, letterSpacing:4, color:"rgba(242,241,237,0.55)", marginBottom:4 }}>26 S/S</p>
                <p style={{ fontFamily:"'DM Serif Display',serif", fontSize:20, color:C.bg }}>{item?.label || ""}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA 바 */}
        <div
          onClick={() => onGoShop && onGoShop("All")}
          style={{ cursor:"pointer", borderTop:"1px solid rgba(242,241,237,0.1)", marginTop:2 }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(242,241,237,0.04)"}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
        >
          <div className="about-cta-inner" style={{ maxWidth:1440, margin:"0 auto", padding:"28px 48px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:"rgba(242,241,237,0.35)", textTransform:"uppercase" }}>26 S/S — Full Collection</span>
            <div style={{ display:"flex", alignItems:"center", gap:16 }}>
              <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:15, letterSpacing:1, color:"rgba(242,241,237,0.7)" }}>컬렉션 전체 보기</span>
              <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:12, color:"rgba(242,241,237,0.4)" }}>→</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── INFO GRID ── */}
      <section className="about-info-sec" style={{ background:C.bg, padding:"80px 48px" }}>
        <div className="about-info-grid" style={{ maxWidth:1440, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:48 }}>
          {[
            { label:"Founded", value:"2025", sub:"서울, 대한민국" },
            { label:"Collection", value:"26 S/S", sub:"Spring / Summer" },
            { label:"Made in", value:"KR · VN ", sub:"Korea · Vietnam" },
            { label:"Contact", value:"contactudlk", sub:"@gmail.com" },
          ].map(item => (
            <div key={item.label} style={{ borderTop:`1px solid ${C.border}`, paddingTop:20 }}>
              <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:4, color:C.muted, marginBottom:10, textTransform:"uppercase" }}>{item.label}</p>
              <p style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, fontWeight:400, color:C.ink, marginBottom:4 }}>{item.value}</p>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, fontWeight:300, color:C.muted }}>{item.sub}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer nav={nav} variant="full" />
    </>
  );
}
